import { FormattedReactMessage } from '@99designs/common/i18n/index';
import Checkbox from 'common/components/Checkbox';
import { Field, FieldSet } from 'common/components/Form';
import Paragraph from 'common/components/Paragraph';
import Text from 'common/components/Text';
import { ActionContext } from 'fluxible';
import { submitEmail } from 'launch/actions/emailCollectionActions';
import Link from 'launch/components/Link';
import UserStore from 'launch/stores/UserStore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

// FIXME: Missing types
const connectToStores = require('fluxible-addons-react/connectToStores');

interface Props {
    value?: string;
    isLoggedIn: boolean;
    isEmailMarketingConsentRequired: boolean;
    onChange: () => void;
}

interface State {
    error: string | null;
    subscribeToMarketing: boolean;
}

class EmailField extends Component<Props, State> {
    state: State = {
        error: null,
        subscribeToMarketing: false,
    };

    static contextTypes = {
        executeAction: PropTypes.func.isRequired,
    };

    constructor(props: Props) {
        super(props);
        this.state.subscribeToMarketing = !props.isEmailMarketingConsentRequired;
    }

    static defaultProps: Partial<Props> = {
        value: '',
    };

    isValid(email: string) {
        return email.match(/.+@.+/);
    }

    handleMarketingCheckbox = (subscribeToMarketing: boolean) => {
        this.setState({ subscribeToMarketing }, () => {
            const { value } = this.props;
            if (value && this.isValid(value)) {
                this.updateEmailSubscription();
            }
        });
    };

    handleOnBlur = () => {
        const email = this.props.value;

        if (email && this.isValid(email)) {
            this.setState({
                error: null,
            });

            this.updateEmailSubscription();
        } else if (email === '') {
            this.setState({
                error: null,
            });
        } else {
            this.setState({
                error: __('Please enter a valid email address'),
            });
        }
    };

    updateEmailSubscription() {
        this.context.executeAction(submitEmail, {
            email: this.props.value,
            subscribeToMarketing: this.state.subscribeToMarketing,
        });
    }

    render() {
        if (this.props.isLoggedIn) return null;

        return (
            <FieldSet title={__('Email')}>
                <Field
                    title={__("Enter your email and we'll save your work")}
                    message={
                        this.props.isEmailMarketingConsentRequired ? (
                            <>
                                <Checkbox
                                    checked={this.state.subscribeToMarketing}
                                    onChange={d => this.handleMarketingCheckbox(d.checked)}
                                >
                                    {__(
                                        'Sign me up to receive design tips, business trends and the occasional special offer.'
                                    )}
                                </Checkbox>
                            </>
                        ) : null
                    }
                    htmlFor="email"
                    errorMessage={this.state.error}
                >
                    <Text
                        id="email"
                        type="email"
                        value={this.props.value}
                        placeholder="john@example.com"
                        onChange={this.props.onChange}
                        onBlur={this.handleOnBlur}
                    />
                    <Paragraph size="small" spacing="half-margin">
                        <FormattedReactMessage
                            message={__(
                                "We'll hold your data according to our <privacyLink>Privacy Policy</privacyLink>."
                            )}
                            replacements={{
                                privacyLink: (
                                    <Link
                                        noWrap={true}
                                        href="/legal/privacy"
                                        target="_blank"
                                        variations={['default']}
                                    />
                                ),
                            }}
                        />
                    </Paragraph>
                </Field>
            </FieldSet>
        );
    }
}

export default connectToStores(EmailField, [UserStore], (context: ActionContext) => {
    const userStore = context.getStore(UserStore);

    return {
        isEmailMarketingConsentRequired: userStore.isEmailMarketingConsentRequired(),
        isLoggedIn: userStore.loggedIn,
    };
});
